import type { ID, NodeItem } from '@octopus-do/octopus-project-core'
import { useMemo } from 'react'

import { SearchEntity, type SearchResult, useSearch } from '../../Search'

export interface StructureSearch {
  pageIds: Set<ID>
  result: SearchResult
  hasContentMatches: boolean
}

const CONTENT_ENTITIES: SearchEntity[] = [
  SearchEntity.BLOCK,
  SearchEntity.BLOCK_NOTE,
  SearchEntity.NOTE,
  SearchEntity.COMMENT,
]

// One search pass for the whole panel: the page hits filter the tree, the rest
// are listed under it. Running useSearch once keeps fuzzysort off the blocks
// and notes twice per keystroke.
export const useStructureSearch = (query: string): StructureSearch => {
  const result = useSearch(query)

  return useMemo(
    () => ({
      result,
      pageIds: new Set<ID>(
        Object.values(result[SearchEntity.PAGE]).map(
          (page: NodeItem) => page.id
        )
      ),
      hasContentMatches: CONTENT_ENTITIES.some(
        (entity) => Object.keys(result[entity]).length > 0
      ),
    }),
    [result]
  )
}
